export default __webpack_public_path__ + "static/media/thumbnail2.f2ada441.jpg";